// extracted by mini-css-extract-plugin
export default {"main":"dvxOAu3ipoCqko9zOfqR","icon":"e7Tybv4Ntd_dFJBemAo4","date":"oaTfTGe8s22vw93olBDJ","placeHolderShimmer":"YYzLGic3FfZjK0bQ7ern"};